/* PB Bundle — Single/Double/Triple set the pack size (1/2/3); the quantity
   selector sets how many packs. ATC adds (packSize x qty) and STAYS on the
   page — no redirect, no cart drawer. All products are single-variant. */
(function () {
  'use strict';

  // Pull one element's innerHTML out of a Section Rendering API payload string.
  function sectionInnerHTML(html, selector) {
    try {
      var el = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
      return el ? el.innerHTML : null;
    } catch (e) { return null; }
  }

  // Swap the header cart-count bubble + drawer contents in place from the add
  // response's `sections`. Mirrors the theme's product-form.js render, minus the
  // drawer open() — so the top-right count updates instantly and the drawer is
  // correct whenever the user chooses to open it.
  function refreshCartUI(data) {
    var sections = data && data.sections;
    if (!sections) return;

    // (1) Top-right cart-count bubble.
    var bubble = document.getElementById('cart-icon-bubble');
    if (bubble && sections['cart-icon-bubble']) {
      var b = sectionInnerHTML(sections['cart-icon-bubble'], '.shopify-section');
      if (b !== null) bubble.innerHTML = b;
    }

    // (2) Drawer contents (do NOT open it).
    var drawerInner = document.getElementById('CartDrawer');
    if (drawerInner && sections['cart-drawer']) {
      var d = sectionInnerHTML(sections['cart-drawer'], '#CartDrawer');
      if (d !== null) drawerInner.innerHTML = d;
    }
    var drawerEl = document.querySelector('cart-drawer');
    if (drawerEl) drawerEl.classList.remove('is-empty');
  }

  function initBundle(root) {
    if (root.__pbInit) return;
    root.__pbInit = true;

    var tiers = Array.prototype.slice.call(root.querySelectorAll('.pb-bd30__tier'));
    var atc = root.querySelector('[data-pb30-atc]');
    var label = root.querySelector('[data-pb30-atc-label]');
    var qtyInput = root.querySelector('[data-pb30-qty-input]');
    var minusBtn = root.querySelector('[data-pb30-qty-minus]');
    var plusBtn = root.querySelector('[data-pb30-qty-plus]');
    var cartGif = root.querySelector('[data-pb30-cart-gif]');
    var variantId = root.getAttribute('data-variant');
    var available = root.getAttribute('data-available') === 'true';

    // Default pack = whichever tier is pre-selected (Triple).
    var initialTier = root.querySelector('.pb-bd30__tier.is-active');
    var packSize = initialTier ? (parseInt(initialTier.getAttribute('data-qty'), 10) || 1) : 1;

    // Live-update the pre-order deposit block (30th) with the selected tier x qty.
    // Due = items x unit price (the deposit); Remaining = Due x 3. Same maths as
    // the static block, just recomputed as the shopper changes tier or quantity.
    var depEl = document.querySelector('[data-pb-dep]');
    var depDue = depEl && depEl.querySelector('[data-pb-dep-due]');
    var depRem = depEl && depEl.querySelector('[data-pb-dep-rem]');
    var depUnit = depEl ? (parseInt(depEl.getAttribute('data-unit-price'), 10) || 0) : 0;
    var depCur = depEl ? (depEl.getAttribute('data-currency') || 'USD') : 'USD';
    var depFmt = null;
    try { depFmt = new Intl.NumberFormat('en-US', { style: 'currency', currency: depCur, minimumFractionDigits: 2 }); } catch (e) {}
    function updateDeposit() {
      if (!depEl || !depFmt) return;
      var items = packSize * readQty();
      var due = depUnit * items;
      if (depDue) depDue.textContent = depFmt.format(due / 100);
      if (depRem) depRem.textContent = depFmt.format((due * 3) / 100);
    }

    tiers.forEach(function (btn) {
      btn.addEventListener('click', function () {
        tiers.forEach(function (t) {
          var on = t === btn;
          t.classList.toggle('is-active', on);
          t.setAttribute('aria-checked', on ? 'true' : 'false');
        });
        packSize = parseInt(btn.getAttribute('data-qty'), 10) || 1;
        updateDeposit();
      });
    });

    // Quantity selector (own handlers so it works regardless of theme JS).
    function readQty() {
      var n = parseInt(qtyInput && qtyInput.value, 10);
      return (isNaN(n) || n < 1) ? 1 : n;
    }
    function setQty(n) {
      if (qtyInput) qtyInput.value = Math.max(1, n);
      updateDeposit();
    }

    updateDeposit(); // initial sync (Single default)
    if (minusBtn) minusBtn.addEventListener('click', function (e) {
      e.stopPropagation(); setQty(readQty() - 1);
    });
    if (plusBtn) plusBtn.addEventListener('click', function (e) {
      e.stopPropagation(); setQty(readQty() + 1);
    });
    if (qtyInput) qtyInput.addEventListener('change', function () { setQty(readQty()); });

    if (!available || !atc) return;

    atc.addEventListener('click', function () {
      if (atc.classList.contains('is-loading')) return;
      atc.classList.add('is-loading');
      var qty = packSize * readQty();

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        // Ask Shopify to also render the header cart-count bubble + drawer so we
        // can refresh them in place (Section Rendering API) — same sections the
        // theme's own product-form.js requests.
        body: JSON.stringify({
          items: [{ id: Number(variantId), quantity: qty }],
          sections: 'cart-icon-bubble,cart-drawer',
          sections_url: window.location.pathname
        })
      })
        .then(function (res) { if (!res.ok) throw new Error('add failed'); return res.json(); })
        .then(function (data) {
          // Stay on the page. Brief confirmation, then revert. No drawer.
          atc.classList.remove('is-loading');
          if (label) {
            var prev = label.textContent;
            label.textContent = 'ADDED ✓';
            setTimeout(function () { label.textContent = prev; }, 1600);
          }
          // Reveal the confirmation GIF just above the ATC button, then fade it
          // back out. It loops on its own while visible.
          if (cartGif) {
            cartGif.classList.add('is-visible');
            clearTimeout(root.__pbGifTimer);
            root.__pbGifTimer = setTimeout(function () {
              cartGif.classList.remove('is-visible');
            }, 3000);
          }
          // Refresh the top-right cart count (and drawer contents) immediately,
          // in place, without opening the drawer.
          refreshCartUI(data);
          // Nudge the theme's cart count to refresh if it listens for this.
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        })
        .catch(function () {
          atc.classList.remove('is-loading');
          if (label) { label.textContent = 'TRY AGAIN'; setTimeout(function () { label.textContent = 'ADD TO CART'; }, 1600); }
        });
    });
  }

  function boot() {
    document.querySelectorAll('[data-pb30-bundle]').forEach(initBundle);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
